module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.prefixCarouselItemClass,
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0886ed46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/carousel-item.vue
// module id = 341
// module chunks = 0